import * as React from 'react';
import { Drawer } from 'antd';
import { NiButton } from '@component/index';
import { localizedString } from '@locale/index';
import { DiffComp } from './diff-comp';
import { DiffNodeConfig } from './node-config';
import '@style/component/diff-drawer.less';

export interface DiffDrawerProps {
  title?: string;
  basePath: string[];
  rootNode?: DiffNodeConfig;
  masterData?: any;
  localData?: any;
  visible: boolean;
  onRevert?: () => void;
  onClose?: () => void;
}

export interface DiffDrawerState { }

export class DiffDrawer extends React.PureComponent<
  DiffDrawerProps,
  DiffDrawerState
> {
  render() {
    const {
      title,
      onClose,
      visible,
      masterData,
      localData,
      rootNode,
      basePath,
      onRevert
    } = this.props;

    return (
      <Drawer
        className="diff-drawer"
        title={title || localizedString('common_diff_info')}
        placement="right"
        closable={false}
        width={640}
        onClose={onClose}
        open={visible}
      >
        <div className="drawer-body">
          <DiffComp
            basePath={basePath}
            rootNode={rootNode}
            masterData={masterData}
            localData={localData}
          />
          <div className="diff-drawer-footer">
            {onRevert
              &&
              <NiButton
                type="primary"
                onClick={() => {
                  if (onClose) {
                    onClose();
                  }
                  onRevert();
                }}
              >
                {localizedString('diff_info_revert_to_master')}
              </NiButton>
            }
          </div>
        </div>
      </Drawer>
    );
  }
}
